
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M4 15.1V9.6C4 8 5.3 6.7 6.9 6.7h2.6V18H6.9C5.3 18 4 16.7 4 15.1zM10.9 30.6L7.7 19.3h4.5l3.1 11.3h-4.4zM25.1 22.6c-1.7-1.7-5.4-4.3-12.3-4.6h-2.1V6.7h1c7.5 0 11.5-2.8 13.3-4.6v20.5zM26.4 15.6V9.2c.9.8 1.5 2 1.5 3.2.1 1.2-.5 2.4-1.5 3.2z"}})])
          )
        }
      }
    